import { useEffect, useRef, useState } from "react";
import { GameShell, useGameLoop, beep } from "./_gameKit";

export default function JixxeoDotTap() {
  const canvasRef = useRef(null);
  const [running, setRunning] = useState(true);
  const [score, setScore] = useState(0);
  const [missed, setMissed] = useState(0);
  const [best, setBest] = useState(() => Number(localStorage.getItem("jixxeo_dottap_best") || 0));
  const dotsRef = useRef([]);
  const spawnRef = useRef(0);
  const [time, setTime] = useState(45);

  useEffect(() => {
    if (!running) return;
    const t = setInterval(() => setTime((s) => {
      if (s <= 1) { setRunning(false); return 0; }
      return s - 1;
    }), 1000);
    return () => clearInterval(t);
  }, [running]);

  const tapAt = (e) => {
    if (!running) return;
    const rect = canvasRef.current.getBoundingClientRect();
    const cvs = canvasRef.current;
    const scaleX = cvs.width / rect.width, scaleY = cvs.height / rect.height;
    const px = (e.clientX - rect.left) * scaleX;
    const py = (e.clientY - rect.top) * scaleY;
    let hit = -1;
    dotsRef.current.forEach((d, i) => {
      const dx = d.x - px, dy = d.y - py;
      if (Math.hypot(dx, dy) < d.r + 6) hit = i;
    });
    if (hit >= 0) {
      beep(880, 0.08);
      dotsRef.current.splice(hit, 1);
      setScore((s) => s + 1);
    }
  };

  useGameLoop(canvasRef, ({ ctx, w, h, dt }) => {
    ctx.fillStyle = "#050510"; ctx.fillRect(0, 0, w, h);
    spawnRef.current -= dt;
    if (running && spawnRef.current <= 0) {
      spawnRef.current = 0.55 - Math.min(0.35, score * 0.007);
      const r = 22 + Math.random() * 14;
      dotsRef.current.push({
        x: 30 + Math.random() * (w - 60),
        y: 40 + Math.random() * (h - 80),
        r, born: performance.now(), life: 1200 + Math.random() * 600,
        color: ["#00F0FF","#39FF14","#FFE300","#FF003C","#8A2BE2"][Math.floor(Math.random() * 5)],
      });
    }
    const now = performance.now();
    dotsRef.current = dotsRef.current.filter((d) => {
      const age = now - d.born;
      if (age > d.life) { setMissed((m) => m + 1); return false; }
      const alpha = 1 - age / d.life;
      ctx.globalAlpha = alpha;
      ctx.fillStyle = d.color; ctx.shadowColor = d.color; ctx.shadowBlur = 22;
      ctx.beginPath(); ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2); ctx.fill();
      ctx.shadowBlur = 0; ctx.globalAlpha = 1;
      return true;
    });
  }, running);

  useEffect(() => {
    if (!running && score > best) { setBest(score); localStorage.setItem("jixxeo_dottap_best", String(score)); }
  }, [running, score, best]);

  const restart = () => { dotsRef.current = []; setScore(0); setMissed(0); setTime(45); setRunning(true); };

  useEffect(() => {
    const cvs = canvasRef.current; if (!cvs) return;
    cvs.addEventListener("pointerdown", tapAt);
    return () => cvs.removeEventListener("pointerdown", tapAt);
    // eslint-disable-next-line
  }, [running]);

  return (
    <GameShell canvasRef={canvasRef} title="Jixxeo Dot Tap" accent="#39FF14"
      adGame="jixxeo-dot-tap"
      chips={[["Time", `${time}s`], ["Score", score], ["Missed", missed], ["Best", best]]}
      instructions="Tap the dots before they fade"
      gameOver={!running ? { title: "Time!", subtitle: `${score} taps · ${missed} missed` } : null}
      onRestart={restart}
    />
  );
}
